(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  const syncFaqAria = (scope) => {
    scope.querySelectorAll('.section-faq [data-accordion-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', trigger.classList.contains('accordion-is-open') ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.section-faq [data-accordion-trigger]');
    if (!trigger) return;
    requestAnimationFrame(() => syncFaqAria(trigger.closest('[data-accordion-group]')));
  });

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => syncFaqAria(event.target));
  });

  requestAnimationFrame(() => syncFaqAria(document));

  } catch(e) { console.error(e); }
})();
})();
